import React, { useState } from 'react';
import { useDispatch} from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import { AuthWrapper } from './style';
import { login } from '../../../../redux/authentication/actionCreator';
import Heading from '../../../../components/heading/heading';

const SignIn = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [loginError, setLodginError] = useState(false);
  const [form] = Form.useForm();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleSubmit = () => {
    setLoading(true);
    dispatch(login(username, password))
    .then(() => {
      setLodginError('');
      history.push('/admin');
      window.location.reload();
    })
    .catch((e) => {
      setLodginError(e);
      setLoading(false);
    });
  };

  return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form name="login" form={form} onFinish={handleSubmit} layout="vertical">
          <Heading as="h3">
            Sign in to <span className="color-secondary">Admin</span>
          </Heading>
          <Form.Item
            name="username"
            rules={[{ message: 'Please input your username!', required: true }]}
            initialValue=""
            label="Username"
          >
            <Input placeholder="Username" onChange={onChangeUsername} value={username}/>
          </Form.Item>
          <Form.Item 
            name="password" 
            rules={[{ message: 'Please input your password!', required: true }]}
            initialValue="" 
            label="Password">
            <Input.Password placeholder="Password" onChange={onChangePassword} value={password}/>
          </Form.Item >
          <Form.Item>
            <Button className="btn-signin" htmlType="submit" type="primary" size="large" disabled={loading}>
              {loading ? 'Loading...' : 'Sign In'}
            </Button>
          </Form.Item>
          {loginError ? <div className="ant-form-item-explain-error">{loginError}</div> : ''}
        </Form>
      </div>
    </AuthWrapper>
  );
}

export default SignIn;
